import { Pipe, PipeTransform } from '@angular/core';
import { IIdentityInfo, ISfpd, ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Pipe({
  name: 'getIdentityInfo'
})
export class GetIdentityInfoPipe implements PipeTransform {

  public transform(input: ITraveller): Array<IIdentityInfo | ISfpd> {
    if (!input) {
      return [];
    }

    const identityInfoList: Array<IIdentityInfo | ISfpd> = [
        ...(input.passport ? input.passport : []),
        ...(input.identityCard ? input.identityCard : []),
        ...(input.secureFlightPassengerData ? [input.secureFlightPassengerData] : [])
    ];

    return identityInfoList;
  }

}
